import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const GMKDraculaR2 = () => (
  <ArticleWrapper articleId="gmk_dracula_r2">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>GMK Dracula R2</h1>
        {/* Add your GMK Dracula R2 article content here */}
        <p>This is a placeholder article for the GMK Dracula R2 keycap set. More content coming soon.</p>
      </div>
    </div>
  </ArticleWrapper>
);

export default GMKDraculaR2;
